<template>
  <div class="wrapper">
    <div class="background" :style="{ backgroundColor: backgroundColour }" />
    <div class="container">
      <p class="title -center -regular -t2 -white" v-html="title" />
      <p class="text -center -t5 -white" v-html="description" />
      <form class="form" @submit.prevent="submit">
        <div v-if="!submitted">
          <form-field
            :error-message="
              $v.$dirty &&
                $v.organisation.$error &&
                'Please enter your organisation name'
            "
            label="Organisation name"
            :value.sync="organisation"
          />
          <div class="grid grid-x grid-margin-x">
            <form-field
              class="cell small-12 medium-2"
              :error-message="
                $v.$dirty && $v.nameTitle.$error && 'Please enter your title'
              "
              label="Title"
              :value.sync="nameTitle"
            />
            <form-field
              class="cell small-12 medium-5"
              :error-message="
                $v.$dirty && $v.firstName.$error && 'Please enter your first name'
              "
              label="First name"
              :value.sync="firstName"
            />
            <form-field
              class="cell small-12 medium-5"
              :error-message="
                $v.$dirty && $v.lastName.$error && 'Please enter your last name'
              "
              label="Last name"
              :value.sync="lastName"
            />
          </div>
          <div class="grid grid-x grid-margin-x">
            <form-field
              class="cell small-12 medium-6"
              :error-message="
                $v.$dirty &&
                  $v.emailAddress.$error &&
                  'Please enter your email address'
              "
              label="Email"
              :value.sync="emailAddress"
            />
            <form-field
              class="cell small-12 medium-6"
              label="Phone number (optional)"
              :value.sync="phone"
            />
          </div>
          <form-field
            :error-message="
              $v.$dirty && $v.message.$error && 'Please enter your message'
            "
            label="Your message"
            type="textarea"
            :value.sync="message"
          />
          <div class="button-container">
            <v-button class="button" :loading="submitting">Submit</v-button>
          </div>
        </div>
        <div
          v-if="submitted"
          class="text -center -t2 -white"
          v-html="completeText"
        />
      </form>
    </div>
  </div>
</template>

<script>
import FormField from "@/components/form/Field.vue";
import VButton from "@/components/Button";
import http from "@/http";
import { required, email } from "vuelidate/lib/validators";

export default {
  props: {
    backgroundColour: String,
    completeText: String,
    defaultEmailAddress: String,
    description: String,
    title: String,
  },
  components: {
    FormField,
    VButton,
  },
  data() {
    return {
      emailAddress: "",
      error: false,
      firstName: "",
      lastName: "",
      message: "",
      nameTitle: "",
      organisation: "",
      phone: "",
      reason: null,
      submitting: false,
      submitted: false,
    };
  },
  validations: {
    emailAddress: {
      required,
      email,
    },
    firstName: { required },
    lastName: { required },
    message: { required },
    nameTitle: { required },
    organisation: { required },
  },
  methods: {
    submit() {
      this.submitting = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitting = true;
        http
          .post("contact", this.data)
          .then(() => {
            this.submitted = true;
          })
          .catch(() => {
            this.error = true;
          });
      } else {
        this.submitting = false;
      }
    },
  },
  computed: {
    data() {
      return {
        defaultEmail: this.defaultEmailAddress,
        email: this.emailAddress,
        firstName: this.firstName,
        lastName: this.lastName,
        message: this.message,
        organisation: this.organisation,
        phone: this.phone,
        title: this.nameTitle,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.wrapper {
  position: relative;
  padding: vw-relative(40 0);
}
.container {
  margin: 20px auto 0;
  max-width: 680px;
  @include breakpoint(medium) {
    margin-top: 0;
  }
}
.background {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  width: 100vw;
  z-index: -1;
}
.text {
  margin: 2em 0;
}
.button-container {
  text-align: center;
}
.button {
  width: 200px;
  @include breakpoint(medium) {
    width: 200px;
  }
}
</style>
